/**
 * Import required libraries
 */
import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

/**
 * Import required elements
 */
import NavMenuRender from "./render";

// Material-ui icons
import {
  Work as ProjectsIcon,
  Group as GroupIcon,
  AccountBalance as BackofficeIcon,
  Settings
} from "@material-ui/icons";


/**
 * NavMenu Component
 */
function NavMenu(props) {

  const [items, setItems] = useState(
    [
      //   {
      //   key: "news", // News page
      //   profile: null,
      //   icon: <NewsIcon/>,
      //   additional_clue: null
      // },
      {
        key: "projects", // Project list to open
        profile: null,
        icon: <ProjectsIcon />,
        additional_clue: null
      },
      {
        key: "group", // Group management
        profile: "manager",
        icon: <GroupIcon />,
        additional_clue: null
      },
      {
        key: "backoffice", // backoffice management
        profile: "admin",
        icon: <BackofficeIcon />,
        additional_clue: null
      },
      {
        key: "settings", // Settings page
        profile: null,
        icon: <Settings />,
        additional_clue: null
      }
    ]);

  const { dispatch, navmenu } = props

  const onClose = useCallback(() => {
    if (navmenu.open) {
      dispatch({
        type: "OPEN_NAVMENU",
        open: false
      });
    }
  }, [dispatch, navmenu.open])


  //Updating the number linked to the waiting list of registration
  useEffect(() => {
    //Case "no group" or no waiting registration in the group
    if (props.group === undefined || props.group.registrations.length === 0) {
      let newIt = items;
      newIt[2].additional_clue = null;
      setItems(newIt);
    }
    else {
      let nbRegistrationWaiting = 0
      for (const elem of props.group.registrations) {
        if (props.registration[elem]) {
          if (props.registration[elem].expiration === null) {
            nbRegistrationWaiting++
          }
        }
      }

      let newIt = items;
      newIt[2].additional_clue = { info: nbRegistrationWaiting, path: "group/registrations" };
      setItems(newIt);
    }
  }, [props.registration, props.group.registrations, items, props.group]);


  if (props.dataLoaded) {
    return React.createElement(NavMenuRender, {
      lang: props.lang,
      navmenu: props.navmenu,
      onClose,
      items
    });
  } else return null;
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang, // App language
  navmenu: state.locale.navmenu, // platform navigation menu
  dataLoaded: state.simtopy.dataLoaded,
  group: state.list.group[state.user.groupUid],
  registration: state.list.registration
}))(NavMenu);
